const getFeatureKey = (feature) => feature?.key || feature?.Key || '';

export const getNewlyEnabledFeatures = (previousFeatures = [], nextFeatures = []) => {
  const previousKeys = new Set(previousFeatures.map(getFeatureKey).filter(Boolean));

  return nextFeatures.map(getFeatureKey).filter((key) => key && !previousKeys.has(key));
};

export const buildFeatureActivationPrompt = (featureKey, metadata, t) => {
  if (featureKey === 'auth') {
    const parts = [t('featureActivationAuthPromptBase')];

    if (metadata?.registrationEnabled) {
      parts.push(t('featureActivationAuthPromptRegistration'));
    } else {
      parts.push(t('featureActivationAuthPromptNoRegistration'));
    }

    return parts.join('\n\n');
  }

  if (featureKey === 'database') {
    return t('featureActivationDatabasePrompt');
  }

  return '';
};

export const getFeatureActivationPath = (featureKey, projectId) => {
  if (featureKey === 'auth') {
    return `/workspace/${projectId}/users`;
  }

  if (featureKey === 'database') {
    return `/workspace/${projectId}/requests`;
  }

  return `/workspace/${projectId}`;
};
